import { render, staticRenderFns } from "./Dataroom.vue?vue&type=template&id=c7fdc1de&scoped=true&"
import script from "./Dataroom.vue?vue&type=script&lang=js&"
export * from "./Dataroom.vue?vue&type=script&lang=js&"
import style0 from "./Dataroom.vue?vue&type=style&index=0&id=c7fdc1de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fdc1de",
  null
  
)

export default component.exports